/* Base translations · Engagement settings and team — moved unchanged out of lib/i18n.js (STEP 2 · B2).
   Top-level keys owned by this file (no other base file and not i18n.js define them): engSettings, engTeam. */
export const I18N_BASE_ENGAGEMENT_SETTINGS = {
  en: {
    engSettings: {
      period: "Engagement period", periodHint: "The period start decides the auditor's report edition (15-Dec-2026 switch) and the default disclosure-checklist edition (01-Jan-2027 switch).",
      repFramework: "Reporting framework (Disclosure Checklist)", rfFull: "Full IFRS", rfSme: "IFRS for SMEs",
      rfDesc: "Only this framework's Disclosure Checklist is shown. Changes are logged; answers on the other framework are kept.",
      rfWarn: "{n} checklist answer(s) exist on the current framework. They stay stored and reappear if you switch back. Change the framework?",

      title: "Engagement settings",
      pickPf: "Pick a presentation framework.",
      saved: "Engagement settings saved",
      saveFailed: "Save failed",
      presFramework: "Presentation Framework",
      locked: "Locked — FS already generated",
      lockedDesc: "This engagement has already generated its first set of financial statements. Contact your firm admin if the framework must change.",
      editableDesc: "Governs P&L rendering. Can be changed after FS generation — existing FS versions are kept and the FS is marked \"Regenerate needed\".",
      fsGeneratedNote: "FS already generated — changing the framework keeps the existing FS version read-only and marks the FS \"Regenerate needed — framework changed\".",
      pfWarn: "Change the Presentation Framework from {from} to {to}?\n\nAffected: generated financial statements (existing version kept read-only; marked \"Regenerate needed — framework changed\"), FS mapping / statement titles, Disclosure Checklist answers (kept; they reappear if you switch back).\n\nNothing is deleted. The change is logged.",
      fwMismatch: "Frameworks do not match: FS are presented under {pf} (Full IFRS) while the Disclosure Checklist is on {rf}. Review both settings.",
      requiresEqc: "Requires EQ review",
      eqcOnDesc: "Turning ON unlocks the engagement-level ISQM 2 section (forms 520(a) / 521(a) / 522(a)) for this engagement — visible to Partners immediately; other individuals must still be invited separately via the ISQM tab's \"Manage access\" dialog.",
      eqcOffBlocked: "Turning OFF is blocked if any ISQM 2 form on this engagement already contains data.",
      saving: "Saving…",
      save: "Save",
      isaCitation: "(ISQM 1 — engagement quality reviews; ISA 220 (Revised))",
      engType: "Engagement type",
      engTypePartnerOnly: "Only Partner or Firm Admin can change the engagement type.",
      engTypeHideNotDelete: "Changing the type hides sections that don't apply — no data is deleted. Every change is logged in the audit trail.",
    },
    engTeam: {
      title: "Engagement team",
      desc: "Only assigned users can open this engagement. Partners & Admins always have firm-wide access.",
      pickUser: "Pick a user…",
      allInvited: "Everyone is already on this engagement",
      add: "Add",
      added: "Added",
      removed: "Removed",
      empty: "No members assigned. Only Partners/Admins can see this engagement.",
      removeConfirm: "Remove {name} from this engagement?",
    },
  },
  ar: {
    engSettings: {
      period: "فترة الارتباط", periodHint: "تحدد بداية الفترة إصدار تقرير المراجع (التحول في 15-Dec-2026) والإصدار الافتراضي لقائمة الإفصاحات (التحول في 01-Jan-2027).",
      repFramework: "إطار التقرير المالي (قائمة الإفصاحات)", rfFull: "المعايير الدولية الكاملة", rfSme: "المعيار الدولي للمنشآت الصغيرة والمتوسطة",
      rfDesc: "تُعرض قائمة الإفصاحات لهذا الإطار فقط. تُسجَّل التغييرات؛ وتُحفَظ الإجابات على الإطار الآخر.",
      rfWarn: "توجد {n} إجابة على الإطار الحالي. ستبقى محفوظة وتظهر مجددًا عند الرجوع. هل تريد تغيير الإطار؟",
      title: "إعدادات المهمة",
      pickPf: "اختر إطار العرض.",
      saved: "تم حفظ إعدادات المهمة",
      saveFailed: "فشل الحفظ",
      presFramework: "إطار العرض",
      locked: "مقفل — تم إنشاء القوائم المالية",
      lockedDesc: "هذه المهمة أنشأت أول قوائم مالية لها بالفعل. تواصل مع مسؤول الشركة إذا كان يجب تغيير الإطار.",
      editableDesc: "يحكم عرض الأرباح والخسائر. يمكن تغييره بعد إنشاء القوائم المالية — تُحفَظ النسخ الحالية وتُعلَّم القوائم بـ \"يلزم إعادة الإنشاء\".",
      fsGeneratedNote: "تم إنشاء القوائم المالية — تغيير الإطار يُبقي النسخة الحالية للقراءة فقط ويُعلِّم القوائم بـ \"يلزم إعادة الإنشاء — تغيّر الإطار\".",
      pfWarn: "تغيير إطار العرض من {from} إلى {to}؟\n\nيتأثر: القوائم المالية المُنشأة (تُحفَظ النسخة الحالية للقراءة فقط وتُعلَّم بـ \"يلزم إعادة الإنشاء — تغيّر الإطار\")، ربط القوائم / عناوين القوائم، إجابات قائمة الإفصاحات (محفوظة وتعود عند الرجوع).\n\nلا يُحذف شيء. يُسجَّل التغيير.",
      fwMismatch: "الإطاران غير متطابقين: القوائم المالية معروضة وفق {pf} (المعايير الدولية الكاملة) بينما قائمة الإفصاحات على {rf}. راجع الإعدادين.",
      requiresEqc: "يتطلب مراجعة الجودة (EQ)",
      eqcOnDesc: "التفعيل يفتح قسم ISQM 2 على مستوى المهمة (النماذج 520(a) / 521(a) / 522(a)) لهذه المهمة — يظهر للشركاء مباشرة؛ الأفراد الآخرون يجب دعوتهم بشكل منفصل عبر مربع حوار \"إدارة الوصول\" في تبويب ISQM.",
      eqcOffBlocked: "الإلغاء ممنوع إذا كان أي نموذج ISQM 2 في هذه المهمة يحتوي على بيانات بالفعل.",
      saving: "جاري الحفظ…",
      save: "حفظ",
      isaCitation: "(ISQM 1 — مراجعات جودة الارتباط؛ ISA 220 (Revised))",
      engType: "نوع الارتباط",
      engTypePartnerOnly: "فقط الشريك أو مسؤول الشركة يمكنه تغيير نوع الارتباط.",
      engTypeHideNotDelete: "تغيير النوع يُخفي الأقسام غير المنطبقة — لا يتم حذف أي بيانات. يتم تسجيل كل تغيير في سجل المراجعة.",
    },
    engTeam: {
      title: "فريق المهمة",
      desc: "فقط المستخدمون المعيَّنون يمكنهم فتح هذه المهمة. الشركاء والمسؤولون لديهم صلاحية على مستوى الشركة دائماً.",
      pickUser: "اختر مستخدماً…",
      allInvited: "كل الأشخاص معيَّنون على هذه المهمة",
      add: "إضافة",
      added: "تمت الإضافة",
      removed: "تمت الإزالة",
      empty: "لم يتم تعيين أعضاء. فقط الشركاء والمسؤولون يستطيعون رؤية هذه المهمة.",
      removeConfirm: "إزالة {name} من هذه المهمة؟",
    },
  },
};

export default I18N_BASE_ENGAGEMENT_SETTINGS;
